module.exports = __webpack_public_path__ + "img/ic_tips.7d799ce3.svg";